import { JsonObject, JsonProperty } from "json2typescript";
import { Participant } from "./Participant";
import { ProposalListItem } from "./ProposalListItem";
import { AwardListItem } from "./AwardListItem";
import { PublicationListItem } from "./PublicationListItem";


@JsonObject("SearchResult")
export class SearchResult {

    @JsonProperty("proposals", [])
    public proposals: ProposalListItem[] = [];

    @JsonProperty("awards", [])
    public awards: AwardListItem[] = [];

    @JsonProperty("publications", [])
    public publications: PublicationListItem[] = [];
}


// WEBPACK FOOTER //
// ./src/models/SearchResult.ts